import { useToasts } from 'react-toast-notifications';

export const ToastAlertsNotification = () => {
    const { addToast } = useToasts();

    const notify = (message, appearance = 'info') => {
        addToast(message, {
            appearance, // 'success', 'error', 'warning', 'info'
            autoDismiss: true,
        });
    };

    return {
        success: (msg) => notify(msg, 'success'),
        error: (msg) => notify(msg, 'error'),
        warn: (msg) => notify(msg, 'warning'),
        info: (msg) => notify(msg, 'info'),
    };
};